export const LOAD_COMPANIES = "ADMIN::LOAD_COMPANIES";
export const RESET_COMPANY_STATE = "ADMIN::RESET_COMPANY_STATE";
